export default __webpack_public_path__ + "static/media/Inkedjustin-timberlake-jessica-biel-1_LI.f32b9049.jpg";